import { Box, Button } from '@mui/material';
import React from 'react';
import SightReadingLiveReadout from './SightReadingLiveReadout';
import type {
  SightReadingLiveFrame,
  SightReadingLiveJudgment,
} from '../testing/sightReadingLiveDiagnostics';

const capturedAtMs = Date.now();
const frame: SightReadingLiveFrame = {
  expectedMidiNotes: [60],
  recognizedMidiNotes: [62],
  onsetMidiNotes: [62],
  candidates: [
    { midiNote: 62, confidence: 0.82 },
    { midiNote: 60, confidence: 0.31 },
  ],
  rms: 0.02,
  minRms: 0.01,
  waveform: Array.from({ length: 48 }, (_, index) => Math.sin((index / 47) * Math.PI * 6) * 0.62),
};

const judgments: SightReadingLiveJudgment[] = [
  {
    id: 'wrong-note',
    capturedAtMs,
    midiNote: 60,
    playedMidiNote: 62,
    phase: 'onset',
    scoreTimestamp: 1,
    playedTimestamp: 1.08,
    state: 'WRONG_NOTE',
    recognizedMidiNotes: [62],
    candidateMidiNotes: [60, 62],
  },
  {
    id: 'right-note',
    capturedAtMs: capturedAtMs - 500,
    midiNote: 64,
    playedMidiNote: 64,
    phase: 'onset',
    scoreTimestamp: 0.5,
    playedTimestamp: 0.52,
    state: 'HIT',
    recognizedMidiNotes: [64],
    candidateMidiNotes: [64],
  },
  {
    id: 'missed-note',
    capturedAtMs: capturedAtMs - 1000,
    midiNote: 67,
    playedMidiNote: null,
    phase: 'onset',
    scoreTimestamp: 0,
    playedTimestamp: -1,
    state: 'NEVER_PLAYED',
    recognizedMidiNotes: [],
    candidateMidiNotes: [],
  },
];

/** Development-only fixture for the live sight-reading recognition readout. */
const SightReadingLiveReadoutVisualFixture = () => (
  <Box
    sx={{
      width: '100vw',
      minHeight: '100vh',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      padding: '72px 32px',
      background:
        'radial-gradient(circle at 70% 20%, rgba(41, 98, 148, 0.3), transparent 34%), #07101B',
    }}
  >
    <Box
      data-sight-reading-audio-test-recorder
      sx={{
        width: '330px',
        borderRadius: '12px',
        border: '1px solid rgba(255, 112, 112, 0.7)',
        backgroundColor: 'rgba(5, 11, 19, 0.96)',
        boxShadow: '0 12px 36px rgba(0, 0, 0, 0.32)',
        color: '#EAF2FF',
        padding: '10px 12px',
        fontFamily: 'Lato, sans-serif',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Box sx={{ fontSize: '12px', fontWeight: 900 }}>Sight-reading audio test</Box>
          <Box sx={{ marginTop: '2px', color: 'rgba(234, 242, 255, 0.68)', fontSize: '10px' }}>
            Recording 348 frames · exercise active
          </Box>
        </Box>
        <Box
          aria-label="Recording"
          sx={{
            width: '9px',
            height: '9px',
            borderRadius: '50%',
            backgroundColor: '#FF7070',
            boxShadow: '0 0 0 4px rgba(255, 112, 112, 0.12)',
          }}
        />
      </Box>
      <Button
        variant="contained"
        color="error"
        size="small"
        sx={{
          minHeight: '30px',
          marginTop: '8px',
          borderRadius: '999px',
          paddingX: '10px',
          textTransform: 'none',
          fontSize: '11px',
          fontWeight: 800,
        }}
      >
        Stop test
      </Button>
      <SightReadingLiveReadout frame={frame} activeBridgeMidiNotes={[62]} judgments={judgments} />
    </Box>
  </Box>
);

export default SightReadingLiveReadoutVisualFixture;
